<template>
  <div class="activehelp" v-if="ti != 0">
    <div class="page1" v-if="qi == 0">
      <div class="list" v-for="(q,i) in questions[ti-1]" :key="'q'+i" @click="showQ(i)">{{q.q}}</div>
    </div>
    <div v-else>
      <div class="question">{{questions[ti-1][qi-1].q}}</div>
      <div class="answer" v-if="typeof questions[ti-1][qi-1].a == 'string'" v-html="questions[ti-1][qi-1].a"></div>
      <div v-else>
        <div class="troublelist" v-for="(t,i) in questions[ti-1][qi-1].a" :key="'trouble'+i" @click="toTrouble(i)">{{t.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import questions from '../../assets/js/bs_questions'
export default {
  data(){
    return {
      ti: 0,
      qi: 0,
      titles: ["激活帮助","账号问题","驾驶出行","ADAS安全辅助","信息娱乐","APP使用问题","车辆升级","用电安全","车辆保养","故障自检"],
      questions: questions
    }
  },
  mounted(){
    this.ti = parseInt(this.$route.params.ti||0)
    this.qi = parseInt(this.$route.params.qi||0)
    document.title = this.titles[this.ti-1]
  },
  watch :{
    '$route': function(to,from){
      window.location.reload()
    }
  },
  methods: {
    showQ(i){
      this.$router.push("/bs/help/"+this.ti+"/"+(i+1))
    },
    toTrouble(i){
      this.$router.push("/bs/trouble/"+i)
    }
  }
}
</script>

<style lang="less" scoped>
.activehelp{
  min-height: 100%;
  box-sizing: border-box;
  background: #111117;
  padding: 40px 32px;
  .list{
    color: #F2F2F7;
    font-size: 14px;
    margin-bottom: 32px;
  }
  .question{
    color: #F2F2F7;
    margin-bottom: 20px;
    font-weight: 500;
  }
  .answer{
    font-size: 14px;
    line-height: 21px;
    color: #C7CAD1;
  }
  .troublelist{
    font-size: 14px;
    color: #fff;
    line-height: 36px;
    position: relative;
  }
  .troublelist::before{
    content: "";
    width: 5px;
    height: 5px;
    border-top: 1px solid #fff;
    border-right: 1px solid #fff;
    position: absolute;
    margin: auto;
    top: 0;
    bottom: 0;
    right: 0;
    transform: rotate(45deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/index.vue